import { render, staticRenderFns } from "./QuemDestina.vue?vue&type=template&id=2b10e45e"
import script from "./QuemDestina.vue?vue&type=script&lang=js"
export * from "./QuemDestina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports